export const DELETE_FILE_SUCCESS = 'DELETE_FILE_SUCCESS';

export const deleteFileSuccess = () => ({
    type: DELETE_FILE_SUCCESS,
});
